import { Injectable } from '@angular/core';
import { catchError, Observable, from, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  HttpClient,
  HttpHeaders,
} from '@angular/common/http';
import { handleErrorFunction } from '../shared/helpers/handleError';
import { ToastService } from './toast.service';


import { EntraService } from './entra.service';

/**
 * TestService is responsible for handling test-related HTTP requests.
 * It interacts with the backend API to fetch test data and manages 
 * token acquisition through the Entra service for secure authorization.
 * 
 * This service provides methods for testing the API connection and fetching 
 * test messages.
 */

@Injectable({
  providedIn: 'root',
})
export class TestService {
    private _httpClient: HttpClient;
    private _entraService:EntraService;
    private handleError = handleErrorFunction;

    
  constructor(private http: HttpClient,
    toastService: ToastService,
    entraService:EntraService
  ) 
  {
    this._httpClient = http;
    this._entraService = entraService

  }
  



  /**
   * Tests the endpoint by calling the `GetTestMessage()` method and logging
   * the response or error to the console.
   * It subscribes to the observable and logs the received message or error.
   */
 public testEndpoint(): void {
  
 
  this.GetTestMessage().subscribe({
    next: (message: string) => {
      console.log('Response received:', message);
    },
    error: (err) => {
      console.error('HTTP Error:', err);
    },
  });
}


/**
   * Sends an HTTP GET request to the '/V1/test' endpoint to fetch a test message.
   * The method uses the Entra service to acquire an access token, which is
   * included in the Authorization header for the request.
   * 
   * @returns Observable that emits the test message as a string.
   */
  public GetTestMessage(): Observable<string> {
    const url = `${environment.apiUrl}/V1/test`;
    const headers: HttpHeaders = new HttpHeaders({
   
    });
    const options = { headers, responseType: 'text' as 'json' }
    return this._httpClient
      .get<string>(url, options ) // Specify responseType as 'text'
      .pipe(
        catchError((error) => handleErrorFunction(error)) // Reusing centralized error handler
      );
  
 
    }
}

